import gql from 'graphql-tag'

export const UPDATE_NOTIFICATION = gql`
    mutation UpdateProfile($input: UpdateUserProfileInput) {
        updateUserProfile(input: $input) {
            notifyEmail
            notifyPhone
        }
    }
`
